import { Component, OnInit, inject } from '@angular/core';
import { SubscriptionService } from '../shared/core/state/subscription/subscription.service';
import { PageLoaderService } from '../shared/util/pageloader.service';
import { Invoice, InvoiceStatus } from '../shared/models/invoice.model';
import { finalize } from 'rxjs';
import { Payment } from '../shared/core/state/order/order.model';
import { Router } from '@angular/router';

@Component({
    selector: 'black-invoices',
    templateUrl: './invoices.component.html',
    styleUrl: './invoices.component.css',
    standalone: false,
    host: {
      ngSkipHydration: 'true',
    },
})
export class InvoicesComponent implements OnInit {
  private subscriptionService = inject(SubscriptionService);
  private pageLoaderService = inject(PageLoaderService);
  private router = inject(Router);


  invoices: Invoice[] = [];

  expandedRows: string[] = [];

  ngOnInit(): void {
    this.pageLoaderService.open();
    this.subscriptionService
      .fetchAllInvoices()
      .pipe(finalize(() => this.pageLoaderService.close()))
      .subscribe((invoices) => {
        this.invoices = invoices;
      });
  }

  calculatePayable(total: number, payments: Payment[]) {
    const totalPaid = payments
      .filter((payment) => payment.isApproved)
      .reduce((total, payment) => payment.amount ?? 0 + total, 0);

    return total - totalPaid;
  }

  payInvoice(invoiceId: string) {
    this.router.navigate(['subscription', 'invoice', invoiceId, 'pay']);
  }

  previewInvoice(invoiceId: string) {
    this.router.navigate(['invoices', invoiceId, 'preview']);
  }

  toggleInvoiceRow(invoiceId: string) {
    if (this.expandedRows.includes(invoiceId)) {
      const foundIndex = this.expandedRows.findIndex(
        (value) => value === invoiceId
      );
      this.expandedRows.splice(foundIndex, 1);
    } else {
      this.expandedRows.push(invoiceId);
    }
  }

  isPayButtonDisabled(status: InvoiceStatus) {
    return [InvoiceStatus.CANCELLED, InvoiceStatus.PAID, InvoiceStatus.REFUNDED, InvoiceStatus.REFUND_REQUESTED].includes(status);
  }

  downloadFile(fileUrl: string, fileName: string) {
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
